import { render, staticRenderFns } from "./safe-space-articles.vue?vue&type=template&id=283d3b62"
import script from "./safe-space-articles.vue?vue&type=script&lang=js"
export * from "./safe-space-articles.vue?vue&type=script&lang=js"
import style0 from "./safe-space-articles.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports